<template>
<div >
	<Loader :show="loading"></Loader>
	<b-modal id="modalBrand" :title="title" hide-footer no-close-on-backdrop no-close-on-esc @close="close" size="sm">
		<BrandForm :id="id" @loaded="loading=false" @updated="close()" ></BrandForm>
	</b-modal>	
</div>
</template>

<script>
import BrandForm from '@/views/brands/BrandForm'
import Loader from '@/components/Loader'

export default {
	name: 'BrandModal',
	components:{
		BrandForm,
		Loader
	},
	data () {
		return {
			title: 'Crear marca',
			show: false,
			loading:false,
			id: null
		}
	},
	methods: {
		open (id=null) {
			this.id = id
			if( id!==null ){
				this.loading = true
				this.title = 'Editar marca'
			}
			this.showModal()
		},
		showModal() {
			this.show = true
			this.$bvModal.show('modalBrand')
		},
		close () {
			this.show = false
			this.form = {}
			this.$emit('updated')
			this.$bvModal.hide('modalBrand')
		},
	}
}


</script>
